"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var chart_js_1 = __importDefault(require("chart.js"));
var uniqueId_1 = __importDefault(require("lodash/uniqueId"));
var map_1 = __importDefault(require("lodash/map"));
var palette_1 = require("../utils/palette");
var Chart = /** @class */ (function (_super) {
    __extends(Chart, _super);
    function Chart(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            id: (0, uniqueId_1.default)("chart-".concat(props.type, "-").concat(props.id, "_")),
        };
        return _this;
    }
    Chart.prototype.componentDidMount = function () {
        this.initChart();
    };
    Chart.prototype.initChart = function () {
        var _a = this.props, type = _a.type, highlightLastDataEntry = _a.highlightLastDataEntry, _b = _a.labels, labels = _b === void 0 ? [] : _b, options = _a.options, datasets = _a.datasets, palette = _a.palette;
        var themedDatasets = (0, map_1.default)(datasets, function (item, index) {
            return (0, palette_1.getThemedChart)(item, index, type, palette, highlightLastDataEntry);
        });
        new chart_js_1.default(document.getElementById(this.state.id), {
            type: type,
            data: {
                labels: labels,
                datasets: themedDatasets,
            },
            options: options,
        });
    };
    Chart.prototype.render = function () {
        var additionalClass = this.props.isSmall
            ? ' chart-container--small'
            : '';
        return (react_1.default.createElement("div", { className: "chart-container".concat(additionalClass) },
            react_1.default.createElement("canvas", { id: this.state.id })));
    };
    return Chart;
}(react_1.default.Component));
exports.default = Chart;
